import React, { useState } from "react";
import "./RightSide.css";
// import ThermoFisher from "./Images/ThermoFisher.png";
// import BioSans from "./Images/BioSans.png";
//import EuroBioTech from "./Images/EuroBioTech.png";
import a2m from "./../../Images/a2m ver 2.png";
import EuroBioTech from "./../../Images/EuroBioTech.png";
import BioX_2026 from "./../../Images/BioX 2026.jpeg";
//import Neutrophil_2026 from "./../../Images/BioX 2026.jpeg";
import DirectMessaging from "../DirectMessage/DirectMessaging";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";

function RightSide() {
  const [timeDisplayFuture, setTimeDisplayFuture] = useState("block");
  const [timeDisplayPast, setTimeDisplayPast] = useState("none");
  const userName = localStorage.getItem("userName");
  const photoURL = localStorage.getItem("myPicture");
  const photoRef = UpdateUserPhotoURL(photoURL);
  const userEmail = localStorage.getItem("userEmail");
  console.log(
    "in RightSide after UpdateUserPhotoURL and photoURL = ",
    photoRef,
  );
  const [currentUser, setCurrentUser] = useState({
    displayName: userName,
    email: userEmail,
    photoURL: photoRef,
    createdAt: Date,
    updatedAt: Date,
  });

  const currentUserId = localStorage.getItem("userUID");
  console.log("in RightSide and userUID = ", currentUserId);
  console.log("in RightSide and currentUser = ", currentUser);

  //let currentUserId;
  //if (tempUser) {
  //  currentUserId = tempUser;
  //} else {
  ///  currentUserId = "1DqYAYvfb9MbXJnoq7hoX3efyXS2";
  //}

  function FutureClick() {
    console.log("FutureClick entered");
    setTimeDisplayFuture("block");
    setTimeDisplayPast("none");
  }

  function PastClick() {
    console.log("PastClick entered");
    setTimeDisplayFuture("none");
    setTimeDisplayPast("block");
  }
  return (
    <div className="rightside_main" style={{ marginTop: 10 }}>
      <div style={{ marginBottom: 20 }}>
        {/* <button
          style={{
            width: 220,
            height: 35,
            backgroundColor: "#42b883",
            color: "white",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
          }}
          onClick={() => setIsChatOpen(!isChatOpen)}
        >
          {isChatOpen ? "Close Chat" : "Open Chat"}
        </button> */}

        <DirectMessaging
          currentUser={{
            userId: currentUserId,
            email: userEmail,
            displayName: userName,
          }}
        />
      </div>
      <button
        style={{
          width: 100,
          height: 25,
          backgroundColor: "#1876f2",
          color: "white",
          borderRadius: 10,
          marginLeft: 0,
        }}
        onClick={() => FutureClick()}
      >
        Future Events
      </button>
      <button
        style={{
          width: 100,
          height: 25,
          backgroundColor: "#1876f2",
          color: "white",
          borderRadius: 10,
          marginLeft: 20,
        }}
        onClick={() => PastClick()}
      >
        Past Events
      </button>
      <div>
        <br></br>
      </div>

      <div style={{ display: timeDisplayFuture }} className="vertical-scroll">
        <div className="sidebar-title">
          <h4>Future Events</h4>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3>24-26</h3>
            <span>Aug 2026</span>
          </div>
          <div className="right-event">
            <h4>Next Generation Dx 2026</h4>
            <p>Washington DC., USA</p>
            <a
              href="https://www.nextgenerationdx.com/about-the-event"
              target="_blank"
            >
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3>25-29</h3>
            <span>Aug 2026</span>
          </div>
          <div className="right-event">
            <h4>Bio-X 2026</h4>
            <p>Chengdu, China</p>
            <a href={BioX_2026} target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3>21-23</h3>
            <span>Sept 2026</span>
          </div>
          <div className="right-event">
            <h4>Neutrophil 2026</h4>
            <p>San Diego, CA USA</p>
            <a href="https://theneutrophil.com/" target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3></h3>
            <span>Jan 2027</span>
          </div>
          <div className="right-event">
            <h4>FUNGA Fest 2027</h4>
            <p>Beer Sheva, Israel</p>
            <a href="https://fungafest.com/" target="_blank">
              Web Site
            </a>
          </div>
        </div>
      </div>

      <br></br>
      <div className="sidebar-title">
        <h4>Sponsors</h4>
      </div>
      <div>
        <a href="https://www.a2m.nl/" target="_blank">
          <img
            src={a2m}
            className="sidebar-ads"
            style={{ width: 200, height: 75 }}
          ></img>
        </a>
      </div>
      <br></br>
      <div style={{ display: timeDisplayPast }} className="vertical-scroll">
        <div className="sidebar-title">
          <h4>Past Events</h4>
        </div>
        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3>07-12</h3>
            <span>Dec 2025</span>
          </div>
          <div className="right-event">
            <h4>FUNGA Fest</h4>
            <p>Beer Sheva, Israel</p>
            <a href="https://fungafest.com/" target="_blank">
              Web Site
            </a>
          </div>
        </div>
        <div className="event">
          <div className="left-event" style={{ width: 84 }}>
            <h3>11-13</h3>
            <span>Sept 2025</span>
          </div>
          <div className="right-event">
            <h4>European Biotechnology Congress 2025</h4>
            <p>Tirana, Albania</p>

            <a href={EuroBioTech} target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 160 }}>
            <h3>14-17</h3>
            <span>Sept 2025</span>
          </div>
          <div className="right-event">
            <h4>
              EFF2025 5th INTERNATIONAL CONFERENCE ON ENGINEERING FUTURE FOOD
            </h4>
            <p>Bologna, Italy</p>
            <a href="https://www.aidic.it/eff2025/" target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 80 }}>
            <h3>19-22</h3>
            <span>Sept 2025</span>
          </div>
          <div className="right-event">
            <h4>12th Trends in Medical Mycology</h4>
            <p>Bilbao, Spain</p>
            <a href="https://www.timm2025.org/" target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 120 }}>
            <h3>8-11</h3>
            <span>May 2025</span>
          </div>
          <div className="right-event">
            <h4>Sensor and Measurement Science International Conference</h4>
            <p>Nuremberg, Germany</p>
            <a
              href="https://www.ama-science.org/ama-conferences/smsi2023/"
              target="_blank"
            >
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 100 }}>
            <h3>19-22</h3>
            <span>May 2025</span>
          </div>
          <div className="right-event">
            <h4>35th Anniversary World Congress on Biosensors</h4>
            <p>Lisbon, Portugal</p>
            <a
              href="https://www.elsevier.com/events/conferences/all/anniversary-world-congress-on-biosensors"
              target="_blank"
            >
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 170 }}>
            <h3>11-15</h3>
            <span>April 2025</span>
          </div>
          <div className="right-event">
            <h4>
              Congress of the European Society of Clinical Microbiology and
              Infectious Diseases
            </h4>
            <p>Vienna, Austria</p>
            <a
              href="https://www.escmid.org/congress-events/escmid-global/"
              target="_blank"
            >
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 130 }}>
            <h3>27-29</h3>
            <span>Nov 2024</span>
          </div>
          <div className="right-event">
            <h4>Werable and Implantable Sensors and Electrochemical Devices</h4>
            <p>Lyon, France</p>
            <a
              href="https://wised2024.univ-lyon1.fr/en/pages/wised-2024-home"
              target="_blank"
            >
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 60 }}>
            <h3>28-01</h3>
            <span>Oct-Nov 2024</span>
          </div>
          <div className="right-event">
            <h4>nanoBalkan Conference</h4>
            <p>Tirana, Albania</p>
            <a href="https://www.nanobalkanconf.com/2024/" target="_blank">
              Web Site
            </a>
          </div>
        </div>
        <div className="event">
          <div className="left-event" style={{ width: 80 }}>
            <h3>3-5</h3>
            <span>Oct 2024</span>
          </div>
          <div className="right-event">
            <h4>European Biotechnology Conference</h4>
            <p>Istanbul, Turkey</p>
            <a href="https://eurobiotech2024.eu/" target="_blank">
              Web Site
            </a>
          </div>
        </div>

        <div className="event">
          <div className="left-event" style={{ width: 80 }}>
            <h3>11-15</h3>
            <span>Aug 2024</span>
          </div>
          <div className="right-event">
            <h4>12th International Mycological Congress</h4>
            <p>Maastricht, Netherlands</p>
            <a href="https://imc12.org/" target="_blank">
              Web Site
            </a>
          </div>
        </div>
        <div className="event">
          <div className="left-event" style={{ width: 55 }}>
            <h3>1-3</h3>
            <span>Aug 2024</span>
          </div>
          <div className="right-event">
            <h4>ISHAM Asia Congress</h4>
            <p>Bangkok, Thailand</p>
            <a href="https://isham.asia/" target="_blank">
              Web Site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RightSide;
